export function minutesAgo(date, now = Date.now()) {
  return Math.max(0, Math.floor((now - new Date(date).getTime()) / 60000));
}

export function isFresh(date, now = Date.now(), maxMinutes = 5) {
  return minutesAgo(date, now) <= maxMinutes;
}

export function formatAgo(date, now = Date.now()) {
  const m = minutesAgo(date, now);
  if (m < 1) return 'Дөнгөж сая';
  if (m < 60) return `${m} минутын өмнө`;
  if (m < 1440) return `${Math.floor(m / 60)} цагийн өмнө`;
  return `${Math.floor(m / 1440)} өдрийн өмнө`;
}
